
















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

type typeAxType = 'link' | 'button';
type signupBtnVariant = 'accent' | 'green';

@Component({})
export default class SignupButton extends Vue {
  @Prop({ type: String }) private readonly axId!: string;
  @Prop({ type: String, default: 'Sign up' }) private readonly text?: string;
  @Prop({ type: String, default: 'accent' }) private readonly variant?: signupBtnVariant;
  @Prop({ type: String, default: 'button' }) private readonly axType?: typeAxType;
  @Prop({ type: Boolean, default: false }) private readonly isMathcounts?: boolean;
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  private readonly axExtra?: object;

  private get nextRoute(): string {
    if (this.isMathcounts) {
      return 'teacher_landing';
    }
    if (this.isEducators) {
      return 'teacher_application';
    }
    return 'nux_welcome';
  }

  private get isEducators(): boolean {
    return !!this.$route.meta?.educatorsHome;
  }

  private get link(): string {
    return this.$router.resolve({
      name: this.nextRoute,
    }).href;
  }

  private handleClick(event: any): void {
    event.preventDefault();
    if (this.$route.name === 'chargebee_paywall') {
      this.$store.dispatch('signupModal/signup');
    } else {
      this.$router.push({ name: this.nextRoute });
    }
  }
}
